import React from 'react';
import { Field, getIn } from 'formik';
import { Select as SelectField } from '../../form';

const Select = ({
  children,
  id,
  label,
  onChange,
  disabled,
  ...rest
}) => (
  <Field {...rest}>
    {({ field, form }) => {
      const error = getIn(form.errors, field.name);
      const touch = getIn(form.touched, field.name);

      const onChangeCustom = (e) => {
        field.onChange(e);
        if (onChange) {
          onChange(e);
        }
      };

      return (
        <SelectField
          id={id}
          label={label}
          disabled={disabled}
          {...field}
          onChange={onChangeCustom}
          error={touch && error}
        >
          {children}
        </SelectField>
      );
    }}
  </Field>
);

export default Select;
